import { useContext } from "react";
// NOTE: Cause circular dependency if we import from "components/TermSheets"
import { LegacyTermSheetContext } from "components/TermSheets/LegacyTermSheetProvider";

/**
 * useTermSheetContext - Hook to access termsheet context
 * Throws error if used outside provider
 */
export default function useTermSheetContext() {
  const context = useContext(LegacyTermSheetContext);

  if (!context) {
    throw new Error("useTermSheetContext must be used within a TermSheetProvider");
  }

  return context;
}
